'use client';

import {
  useSubmitBoaFormMutation,
  type BoaFormRequest,
} from '@/hooks/api/useSubmitBoaFormMutation';
import { reportError } from '@/utils/rollbarWrapper';
import { TrackingHelper } from '@/utils/tracking';
import { useState } from 'react';
import { BoaForm, type BoaFormValues } from './BoaForm';

export type BoaPartner = 'aig-flu';

const buildPayload = (
  values: BoaFormValues,
  partner?: BoaPartner
): BoaFormRequest => {
  const [, m, d, y] = values.dob.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)!;
  return {
    handler: 'boa-diamond-honors',
    formData: {
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      phone: values.phone.replace(/\D/g, ''),
      dob: `${y}-${m}-${d}`,
      gender: values.gender,
      sms_opt_in: values.sms_opt_in || false,
      ...(partner && { partner }),
    },
    trackingData: TrackingHelper.getTrackingData(),
  };
};

export const BoaFormContainer = ({
  partner,
  onSuccess,
}: {
  partner?: BoaPartner;
  onSuccess: (firstName: string) => void;
}) => {
  const { mutateAsync, isPending } = useSubmitBoaFormMutation();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const onSubmit = async (values: BoaFormValues) => {
    setErrorMessage(null);
    try {
      await mutateAsync(buildPayload(values, partner));
      onSuccess(values.first_name);
    } catch (error) {
      reportError(error instanceof Error ? error : String(error), {
        context: 'boa-diamond-honors-form',
      });
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <BoaForm
      loading={isPending}
      errorMessage={errorMessage}
      onSubmit={onSubmit}
    />
  );
};
